export enum FeatureFlagRoleType {
  ALL = 'ALL',
  ADMIN = 'ADMIN',
  VENDOR = 'VENDOR',
  VENDOR_ADMIN = 'VENDOR_ADMIN'
};

export enum FeatureFlagValues {
  DOW_JONES = 'dowJones',
  ORDER = 'order',
  COMPANY = 'company',
  PRICEBOOK = 'pricebooks',
  PRODUCT_V2 = 'productV2',
  MARKETING = 'marketingCampaign',
  BRANDS_V2 = 'brandsV2',
  SERVICES = 'services',
  BUSINESS_UNIT = 'businessUnit',
  CREDIT_CHECK = 'creditCheck',
  AI_VARIANT_GENERATION = 'aiVariantGeneration',
  SUBSCRIPTION_PRODUCT = 'subscriptionProduct',
  AFFILIATE_PROGRAM = 'affiliateProgram',
  AI_CHATBOT = 'AiChatBot',
  EDIT_ORDER = 'editOrder',
  PRODUCT_RECOMMENDATIONS = 'productRecommendation',
  PRODUCT_PREVIEW = 'productPreview',
};

export default interface FeatureFlag {
  [name: string]: { enabled: boolean, role: FeatureFlagRoleType };
};
